import styles from "./main-app-menu.module.css";
import { UIIconName } from "PosterEditor/common-components/ui-icon-drawing/ui-icon-type";
import { UIIcon } from "PosterEditor/common-components/ui-icon-drawing/ui-icon";

interface MainAppMenuButtonProps {
  label: string;
  icon: UIIconName;
  onClick: () => void;
}

export const MenuOption = (props: MainAppMenuButtonProps) => {
  return (
    <button className={styles.menuAction} onClick={props.onClick}>
      <UIIcon iconName={props.icon} variant="REGULAR" size={20} />
      {props.label}
    </button>
  );
};
